/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register pages globally

==========================================================================================*/

import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from '@/components/vx-card/VxCard.vue'
import VxList from '@/components/vx-list/VxList.vue'
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon from '@/components/FeatherIcon.vue'
import VxInputGroup from '@/components/vx-input-group/VxInputGroup.vue'
import Nl2br from 'vue-nl2br/src/Nl2br'
import TimeAgo from 'vue2-timeago'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('nl2br', Nl2br)
Vue.component('TimeAgo', TimeAgo)

// v-select component
import vSelect from 'vue-select'

// Set the pages prop default to return our fresh pages
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: (createElement) => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
